import React from "react";
import { Paper, Stack, Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import RevaText from "components/common/RevaText";
import { baseDomain } from "network/api-routes";

const ImportSection = ({ csvFile, handleCsvFileChange, handleExportClick, exportDisabled = false }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <RevaText variant="h6">Importar / Exportar miembros</RevaText>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="start"
        mt={1}
      >
        <Button
          href={`${baseDomain}/csv/members_format.csv`}
          target="_blank"
          variant="outlined"
          startIcon={<DownloadIcon />}
        >
          Descargar plantilla
        </Button>

        <input accept=".csv" id="csvFile" type="file" style={{ display: "none" }} onChange={handleCsvFileChange} />
        <label htmlFor="csvFile">
          <Button variant="contained" component="span" startIcon={<UploadFileIcon />}>
            Seleccionar CSV
          </Button>
        </label>

        <Button variant="outlined" onClick={handleExportClick} disabled={exportDisabled} startIcon={<DownloadIcon />}>
          Exportar miembros filtrados
        </Button>
      </Stack>
    </Paper>
  );
};

export default ImportSection;
